<template>
    <div class="">
        <div class="bg-white-90">
            <div class="flex-column m-sm-4 mb-2 content-full">
                <div class="row">
                    <div class="col-md-6 d-md-flex align-items-md-center">
                        <div class="py-4 py-md-0 text-center text-md-left js-appear-enabled animated fadeIn"
                             data-toggle="appear">
                            <h1 class="font-size-h2 mb-2">{{project.name}}</h1>
                            <h4 class="font-size-base font-w400 text-muted mb-0">{{project.description}}</h4>
                        </div>
                    </div>
                    <div class="col-md-6 d-md-flex align-items-md-center"
                         v-if="accounts.length && hasProjectAccess(['admin', 'owner'])">
                        <div class="row w-100 text-center">
                            <div v-for="(account, idx) of accounts" class="col-6 col-xl-6 js-appear-enabled animated fadeIn"
                                 data-toggle="appear" data-timeout="300" :key="idx">
                                <p class="font-size-h3 font-w600 text-body-color-dark mb-0">
                                    {{formatAmount(account)}}
                                </p>
                                <p class="font-size-sm font-w700 text-uppercase mb-0">
                                    <i class="far fa-chart-bar text-muted mr-1"></i> {{account.name}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-tabs type="border-card" @tab-click="loadTab">
            <el-tab-pane>
                <span slot="label"><i class="si si-home"></i>Overview</span>
                <div class="d-flex justify-content-between align-items-center py-1">
                    <h2 class="h3 font-w400 mb-0">Bulk SMS Overview</h2>
                    <div class="row">
                        <el-date-picker
                            @change="loadPageStats"
                            v-model="dateRange"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="Start date"
                            end-placeholder="End date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                    </div>
                </div>
                <div class="row row-deck bg-body-light">
                    <div class="col-sm-6 col-xl-3 mt-4">
                        <a class="block block-rounded block-link-pop" href="javascript:void(0)">
                            <div
                                class="block-content block-content-full d-flex align-items-center justify-content-between">
                                <div>
                                    <i class="fa fa-2x fa-envelope text-primary"/>
                                </div>
                                <div class="ml-3 text-right">
                                    <p class="font-size-h3 font-w300 mb-0">
                                        {{pageStats.total}}
                                    </p>
                                    <p class="text-muted mb-0">
                                        Messages Sent
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6 col-xl-3 mt-4">
                        <a class="block block-rounded block-link-pop" href="javascript:void(0)">
                            <div
                                class="block-content block-content-full d-flex align-items-center justify-content-between">
                                <div>
                                    <i class="fa fa-2x fa-check text-success"></i>
                                </div>
                                <div class="ml-3 text-right">
                                    <p class="font-size-h3 font-w300 mb-0">
                                        {{pageStats.delivery.deliveredtoterminal || 0}}
                                    </p>
                                    <p class="text-muted mb-0">
                                        Delivered Messages
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6 col-xl-3 mt-4">
                        <a class="block block-rounded block-link-pop" href="javascript:void(0)">
                            <div
                                class="block-content block-content-full d-flex align-items-center justify-content-between">
                                <div>
                                    <i class="fa fa-2x fa-ban text-warning"></i>
                                </div>
                                <div class="ml-3 text-right">
                                    <p class="font-size-h3 font-w300 mb-0">
                                        {{pageStats.delivery.userinblacklist || 0}}
                                    </p>
                                    <p class="text-muted mb-0">
                                        Blocked Messages
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-6 col-xl-3 mt-4">
                        <a class="block block-rounded block-link-pop" href="javascript:void(0)">
                            <div
                                class="block-content block-content-full d-flex align-items-center justify-content-between">
                                <div>
                                    <i class="fa fa-2x fa-clock text-info"></i>
                                </div>
                                <div class="ml-3 text-right">
                                    <p class="font-size-h3 font-w300 mb-0">
                                        {{pageStats.delivery.unsent || 0}}
                                    </p>
                                    <p class="text-muted mb-0">
                                        Pending status
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane>
                <span slot="label"> <i class="si si-people pr-1"></i> Team</span>
                <div class="table-responsive">
                    <table class="table table-borderless table-striped table-vcenter table-sm">
                        <thead>
                        <tr>
                            <th class="text-center" style="width: 100px;">
                                <i class="far fa-user"></i>
                            </th>
                            <th>Name</th>
                            <th style="width: 30%;">Email</th>
                            <th style="width: 15%;">Access</th>
                            <th v-if="hasProjectAccess(['owner'])" class="text-center" style="width: 100px;">Actions
                            </th>
                        </tr>
                        </thead>
                        <tbody v-if="project.hasOwnProperty('members') && project.members.data.length > 0">
                        <tr
                            v-for="(person, index) in project.members.data" :key="index">
                            <td class="text-center">
                                <avatar :size="800" default-img="identicon" :email="person.email" color="#fff"
                                        class="img-avatar img-avatar48 img-avatar-thumb"/>
                            </td>
                            <td class="font-w600">
                                <a href="#">{{person.name}}</a>
                            </td>
                            <td><em class="text-muted">{{person.email}}</em></td>
                            <td>
                                <span class="badge badge-warning">{{person.access}}</span>
                            </td>
                            <td class="text-center" v-if="hasProjectAccess(['owner'])">
                                <div class="btn-group">
                                    <button :disabled="user.id === person.id"
                                            type="button"
                                            class="btn btn-sm btn-danger js-tooltip-enabled"
                                            data-toggle="tooltip"
                                            title="Revoke Access"
                                            @click="revokeProjectAccess(person)"
                                            data-original-title="Edit">
                                        <i class="si si-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
            <el-tab-pane>
                <span slot="label">
                    <i class="si si-link"></i>
                    Callback URLs
                </span>
                <div class="col-auto">
                    <div class="block block-rounded block-bordered">
                        <div class="block-header block-header-default">
                            <div class="block-title">
                                Project Callback URLs
                            </div>
                            <div class="block-options" v-if="hasProjectAccess(['admin', 'owner'])">
                                <button class="btn btn-outline-success btn-sm" @click="addCallback = true">
                                    <i class="fa fa-plus"></i>
                                    Add URL
                                </button>
                            </div>
                        </div>
                        <div class="block-content block-content-full p-1">
                            <table class="table table-striped table-sm">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Service</th>
                                    <th>Callback URL</th>
                                    <th>Verified</th>
                                    <th>Options</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-if="projectCallbacks.length > 0" v-for="(endpoint, key) in projectCallbacks"
                                    :key="key">
                                    <td>{{++key}}</td>
                                    <td>{{endpoint.service}}</td>
                                    <td>{{endpoint.url}}</td>
                                    <td>{{endpoint.verified}}</td>
                                    <td></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane v-if="hasProjectAccess(['owner'])">
                <span slot="label">
                    <i class="si si-anchor">
                    </i>
                    Rates
                </span>
                <div class="block block-rounded block-bordered m-0">
                    <div class="block-header block-header-default">
                        <div class="block-title">
                            Bulk SMS Rates
                        </div>
                    </div>
                    <div class="block-content block-content-full">
                        <table class="table table-striped table-sm">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Network</th>
                                <th>Rate</th>
                                <th>Country</th>
                                <th>Updated At</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="rates.length > 0" v-for="(rate, key) in rates"
                                :key="key">
                                <td>{{++key}}</td>
                                <td>{{rate.network}}</td>
                                <td>{{rate.rate}}</td>
                                <td>KE</td>
                                <td>{{rate.updatedAt}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <!-- Form -->
        <el-dialog title="Add Callback URL" :visible.sync="addCallback">
            <form>
                <div class="form-group">
                    <label>URL</label>
                    <el-input v-model="callback.url" autocomplete="off"></el-input>
                </div>
                <div class="form-group">
                    <label>Callback Service</label>
                    <v-select v-model="callback.service" placeholder="Please select a service" :options="services">
                    </v-select>
                </div>
            </form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addCallback = false">Cancel</el-button>
                <el-button type="primary" @click="addProjectCallback">Confirm</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<style scoped lang="scss">
    .el-tabs--border-card > .el-tabs__content {
        padding: 5px !important;
    }
</style>

<script>
    import * as numeral from 'numeral';
    import {mapGetters} from 'vuex';
    import * as moment from 'moment';
    import VueSelect from 'vue-select';
    import EventBus from '../../bus/events';

    export default {
        name: "ProjectDashboard",
        components: {
            'v-select': VueSelect
        },
        data() {
            return {
                accounts: [],
                dateRange: [
                    moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')
                ],
                addCallback: false,
                callback: {
                    service: '',
                    url: ''
                },
                projectCallbacks: [],
                rates: [],
                services: [
                    {
                        value: "bulk-sms",
                        label: "Bulk SMS Delivery Reports"
                    },
                    {
                        value: "airtime",
                        label: "Airtime Purchase"
                    }
                ],
                pageLoading: false,
                pageStats: {
                    total: 0,
                    delivery: {
                        deliveredtoterminal: 0,
                        failed: 0,
                    }
                }
            }
        },
        beforeMount() {
            this.pageLoading = true;
            this.loadProject();
        },
        mounted() {
            EventBus.$on('project-loaded', () => {
                this.loadPageStats();
                this.loadCallbacks();
                this.loadRates();
            })
        },
        computed: {
            ...mapGetters({
                project: 'getProject',
                apps: 'getApps',
                projectUser: 'getProjectUser',
            })
        },
        watch: {
            formatValue(val) {
                return numeral(val).format('0.0a')
            }
        },
        methods: {
            loadTab() {

            },

            revokeProjectAccess(user) {
                if (this.hasProjectAccess(['owner'])) {
                    this.$confirm(`Are you sure you want to revoke ${user.access} access for ${user.name}`).then(res => {
                        if (res) {
                            axios.post(`projects/${this.project.id}/members/revoke`, {
                                userId: user.id
                            }).then(res => this.loadProject())
                        }
                    });
                }
            },
            /**
             *
             * @param account
             * @returns {string}
             */
            formatAmount(account) {
                return `${account.currency} ` + numeral(account.balance).format('0.0a')
            },

            addProjectCallback() {
                let project = this.$route.params.project;
                axios.post(`projects/${project}/callbacks/create`, this.callback)
                    .then(response => {
                        this.addCallback = false;
                        this.$alert(response.data.message, 'Callback Created');
                        this.loadCallbacks()
                    }).catch(error => {
                    this.$alert(error.message)
                })
            },

            loadCallbacks() {
                let project = this.$route.params.project;
                axios.get(`projects/${project}/callbacks`)
                    .then(response => {
                        this.projectCallbacks = response.data.data
                    });
            },

            loadRates() {
                if (this.hasProjectAccess(['owner'])) {
                    let project = this.$route.params.project;
                    axios.get(`projects/${project}/rates`)
                        .then(response => {
                            this.rates = response.data.data
                        });
                }
            },

            loadPageStats() {
                let project = this.$route.params.project;
                axios.get(`projects/${project}/stats?period=${this.dateRange}`).then((response) => {
                    this.pageStats = response.data.data;
                }).catch(() => {
                    // Handle
                });
                if (this.hasProjectAccess(['admin', 'owner'])) {
                    axios.get(`projects/${this.$route.params.project}/billing-info`).then(response => {
                        this.accounts = response.data.data;
                        this.pageLoading = false;
                    });
                }
            },
            hasProjectAccess(roles) {
                return _.includes(roles, this.projectUser.access);
            }
        }
    }
</script>

<style scoped>
</style>
